<template>
  <v-container>
    <!-- Search -->
    <v-row class="justify-end">
      <v-col md="3" sm="12">
        <v-text-field
          rounded
          filled
          flat
          placeholder="Search"
          class="search"
          prepend-inner-icon="mdi-magnify"
        ></v-text-field>
      </v-col>
    </v-row>

    <!--    Page-->
    <v-row>
      <v-col>
        <v-sheet light rounded>
          <!-- <p class="subtitle-2">Driver's Profie</p> -->
          <v-row
            class="px-10 pt-5 d-flex flex-column flex-md-row align-center justify-between"
          >
            <v-col cols="9" md="3">
              <v-row class="d-flex align-center">
                <v-col>
                  <v-img
                    style="width: 10rem; height: 10rem; border-radius: 50%"
                    contain
                    :src="driver.profile_photo_path"
                  ></v-img>
                </v-col>
                <v-col style="color: #3b4a65">
                  <h2 style="font-weight: 900">{{ driver.name }}</h2>
                  <!-- <p>company name</p> -->
                </v-col>
              </v-row>
            </v-col>
            <v-col class="d-none d-md-block" md="4"></v-col>
            <v-col cols="9" md="5">
              <v-row class="d-flex flex-column flex-sm-row align-end">
                <v-col>
                  <p
                    style="font-size: 12px; background-color: white; "
                    class="primary--text text-left"
                  >
                    * You cannot deactivate a driver when they are on a trip
                  </p>
                  <v-btn
                    rounded
                    style="background-color: white; color: #01288d; border: 1px solid #01288d !important; padding: 0 1rem;"
                    @click="handleDeactivate"
                    v-if="driver.verified === 1"
                    >Deactivate Driver</v-btn
                  >

                  <v-btn
                    rounded
                    style="background-color: white; color: #01288d; border: 1px solid #01288d !important; padding: 0 1rem;"
                    @click="handleActivate"
                    v-if="driver.verified === 0"
                    >Activate Driver</v-btn
                  >
                </v-col>
                <v-col>
                  <WarningModal
                    :handleConfirm="handleConfirm"
                    v-if="$store.getters['Dashboard/showWarningModal']"
                  />

                  <SuccessModal
                    v-if="$store.getters['Dashboard/showSuccessModal']"
                  />
                  <ErrorModal
                    v-if="$store.getters['Dashboard/showErrorModal']"
                  />
                </v-col>
                <v-col class="col-12 col-md-5">
                  <v-dialog v-model="dialog" persistent max-width="600px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="secondary"
                        class="primary--text"
                        style="padding: 0 2rem"
                        rounded
                        dark
                        v-bind="attrs"
                        v-on="on"
                      >
                        Assign Vehicle
                      </v-btn>
                    </template>
                    <v-card
                      color="#f4f7fc"
                      style="
                        background: white;
                        border-radius: 2rem;
                        "
                    >
                      <v-btn
                        x-small
                        outlined
                        @click="dialog = false"
                        fab
                        icon
                        class="float-right mt-5 mr-5"
                      >
                        <v-icon c>
                          mdi-close
                        </v-icon>
                      </v-btn>
                      <v-card-title>
                        <span
                          style="font-family: inherit !important"
                          class="text-h5 text-md-h4 mt-8 mb-8"
                        >
                          Vehicle Details
                          <br />
                          <span
                            style="font-family: inherit !important"
                            class="text-body-1"
                          >
                            Please Fill the form below to assign</span
                          >
                        </span>
                      </v-card-title>
                      <v-card-text>
                        <v-container fluid class="pa-0">
                          <v-row v-if="bio">
                            <v-col cols="12">
                              <span class="text-uppercase">Vehicle</span>
                              <v-select
                                class="mt-8"
                                rounded
                                filled
                                dense
                                :items="vehicles"
                                v-model="vehicle_id"
                                item-value="id"
                                item-text="reg_no"
                                placeholder="Select Vehicle"
                                :rules="rules.vehicle_id"
                                ref="vehicle_id"
                              ></v-select>

                              <span class="text-uppercase">Note</span>
                              <v-textarea
                                name="note"
                                v-model="note"
                                filled
                                rounded
                                dense
                                class="mt-8"
                                placeholder="Reason for Assigning"
                                :rules="rules.note"
                                ref="note"
                              ></v-textarea>
                            </v-col>
                          </v-row>

                          <v-row>
                            <v-col class="d-flex flex-row justify-space-around">
                              <v-btn
                                large
                                rounded
                                color="secondary"
                                class="primary--text"
                                style="padding: 0 2rem"
                                :loading="modalLoading"
                                @click="handleAssign"
                              >
                                Assign Driver
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-dialog>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col class="col-12" cols="12">
              <h4 class="mb-4" style="color: #01288d">Driver's Details</h4>
              <div>
                <v-card
                  class="d-flex flex-wrap"
                  color="grey lighten-2"
                  flat
                  tile
                >
                  <v-card class="col-12 col-sm-6 col-lg-3" outlined tile>
                    <span class="text-uppercase" style="color: #707070">
                      First Name:
                    </span>
                    <span style="color: #3b4a65; font-weight: 600 !important;">
                      {{ driver.first_name }}
                    </span>
                  </v-card>
                  <v-card class="col-12 col-sm-6 col-lg-3" outlined tile>
                    <span class="text-uppercase" style="color: #707070">
                      Last Name:
                    </span>
                    <span style="color: #3b4a65; font-weight: 600 !important;">
                      {{ driver.last_name }}
                    </span>
                  </v-card>
                  <v-card class="col-12 col-sm-6 col-lg-3" outlined tile>
                    <span class="text-uppercase" style="color: #707070">
                      Route:
                    </span>
                    <span style="color: #3b4a65; font-weight: 600 !important;">
                      {{ driver.area_of_operation }}
                    </span>
                  </v-card>
                  <v-card class="col-12 col-sm-6 col-lg-3" outlined tile>
                    <span class="text-uppercase" style="color: #707070">
                      Bank Account Name:
                    </span>
                    <span style="color: #3b4a65; font-weight: 600 !important;">
                      {{ accountName }}
                    </span>
                  </v-card>
                  <v-card class="col-12 col-sm-6 col-lg-3" outlined tile
                    ><span class="text-uppercase" style="color: #707070">
                      Phone Number:
                    </span>
                    <span style="color: #3b4a65; font-weight: 600 !important;">
                      {{ driver.phone_number }}
                    </span>
                  </v-card>
                  <v-card class="col-12 col-sm-6 col-lg-3" outlined tile>
                    <span class="text-uppercase" style="color: #707070">
                      Email Address:
                    </span>
                    <span style="color: #3b4a65; font-weight: 600 !important;">
                      {{ driver.email }}
                    </span>
                  </v-card>
                  <v-card class="col-12 col-sm-6 col-lg-3" outlined tile>
                    <span class="text-uppercase" style="color: #707070">
                      Bank Name
                    </span>
                    <span style="color: #3b4a65; font-weight: 600 !important;">
                      {{ bankName }}
                    </span>
                  </v-card>
                  <v-card class="col-12 col-sm-6 col-lg-3" outlined tile>
                    <span class="text-uppercase" style="color: #707070">
                      Account number:
                    </span>
                    <span style="color: #3b4a65; font-weight: 600 !important;">
                      {{ accountNumber }}
                    </span>
                  </v-card>
                </v-card>
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col class="ma-5">
              <v-tabs v-model="tab">
                <v-tabs-slider color="secondary"></v-tabs-slider>
                <v-tab>ACTIVITIES/DELIVERIES</v-tab>
                <v-tab>Documents</v-tab>
              </v-tabs>
              <v-tabs-items v-model="tab">
                <v-tab-item>
                  <v-data-table
                    :headers="headers"
                    :items="$store.getters['Dashboard/driverTrips']"
                    show-select
                  >
                  </v-data-table>
                </v-tab-item>
                <v-tab-item>
                  <v-data-table
                    :headers="documentHeaders"
                    :items="documents"
                    show-select
                  >
                    <template v-slot:top>
                      <v-row>
                        <v-col cols="6" class="px-10">
                          <v-form class="compact-form">
                            <v-row no-gutters> </v-row>
                          </v-form>
                        </v-col>
                      </v-row>
                    </template>
                    <template v-slot:item.doctype="{ item }">
                      <a
                        class="text-decoration-none"
                        target="_blank"
                        rel="noopener noreferrer"
                        :href="item.insurance_cert_doc"
                      >
                        <v-btn
                          small
                          width="5rem"
                          rounded
                          style="color: #01288d"
                          v-if="item.insurance_cert_doc"
                          >{{ item.doctype }}
                          <v-icon right color="secondary">mdi-export</v-icon>
                        </v-btn>
                        <p v-else>N/A</p>
                      </a>
                    </template>
                  </v-data-table>
                </v-tab-item>
              </v-tabs-items>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import WarningModal from "@/components/Dashboard/Modals/WarningModal";
import SuccessModal from "@/components/Dashboard/Modals/SuccessModal";
import ErrorModal from "@/components/Dashboard/Modals/ErrorModal";
export default {
  name: "DriverCard",
  components: {
    WarningModal,
    SuccessModal,
    ErrorModal
  },
  data: function() {
    return {
      tab: null,
      bio: true,
      checkbox: "",
      dialog: false,
      dialogDelete: false,
      snackbar: false,
      tabTwo: null,

      vehicle_id: "",
      note: "",
      modalLoading: false,
      headers: [
        { text: "Trip No.", align: "start", value: "trip_no" },
        { text: "Recipient Name", value: "recipient_name" },
        { text: "Recipient Phone", value: "recipient_phone_number" },
        { text: "Pickup", value: "pick_up_name" },
        { text: "Destination", value: "destination_name" },
        { text: "Mode of Payment", value: "mode_of_payment" },
        { text: "Notes", value: "notes" },
        { text: "Status", value: "status" }
      ],

      documentHeaders: [
        { text: "Title", align: "start", value: "title" },
        { text: "Type of Doc", align: "start", value: "doctype" }
      ],
      documents: [
        {
          id: 1,
          title: "ID Photo",
          doctype: "IMAGE"
        },
        {
          id: 2,
          title: "Driving Licence",
          doctype: "PDF"
        },
        {
          id: 3,
          title: "Certificate of Good Conduct",
          doctype: "PDF"
        },
        {
          id: 4,
          title: "Profile Photo",
          doctype: "IMAGE"
        }
      ]
    };
  },
  methods: {
    handleAssign() {
      let isValid = true;

      for (let key in this.rules) {
        isValid = isValid ? this.$refs[key].validate(true) : false;
      }

      if (isValid) {
        const vehicle_id = +this.vehicle_id;
        const vehicle = this.vehicles.find(v => v.id === vehicle_id);
        const vehicle_name = vehicle.reg_no;
        const rider_id = this.driver.id;
        const rider_name = this.driver.name;
        const data = { vehicle_id, vehicle_name, rider_id, rider_name };
        this.$store.dispatch("Dashboard/assignDriverVehicle", data);
      }
    },

    handleActivate() {
      const modalDescription = `Are you sure you want to activate ${this.driver.name}, an Email will be sent to ${this.driver.email} to notify them.`;
      const modalText = `Call ${this.driver.phone_number}`;
      this.$store.dispatch("Dashboard/setModalDescription", modalDescription);
      this.$store.dispatch("Dashboard/setModalText", modalText);
      this.activate = true;
      this.$store.dispatch("Dashboard/showWarningModal");
    },

    handleDeactivate() {
      const modalDescription = `Are you sure you want to deactivate ${this.driver.name}, an Email will be sent to ${this.driver.email} to notify them.`;
      const modalText = `Call ${this.driver.phone_number}`;
      this.$store.dispatch("Dashboard/setModalDescription", modalDescription);
      this.$store.dispatch("Dashboard/setModalText", modalText);
      this.$store.dispatch("Dashboard/showWarningModal");
    },

    handleConfirm() {
      if (this.driver.verified === 0) {
        this.$store.dispatch("Dashboard/activateUser", this.driver);
      } else {
        this.$store.dispatch("Dashboard/deactivateUser", this.driver);
      }
    }
  },

  computed: {
    driver() {
      return this.$route.params.driver;
    },
    vehicles() {
      return this.$store.getters["Dashboard/vehicles"];
    },
    accountName() {
      return this.driver?.bank_details?.account_name &&
        this.driver?.bank_details?.account_name !== "undefined"
        ? this.driver?.bank_details?.account_name
        : "";
    },
    bankName() {
      return this.driver?.bank_details?.bank_name &&
        this.driver?.bank_details?.bank_name !== "undefined"
        ? this.driver?.bank_details?.bank_name
        : "";
    },
    accountNumber() {
      return this.driver?.bank_details?.account_number &&
        this.driver?.bank_details?.account_number !== "undefined"
        ? this.driver?.bank_details?.account_number
        : "";
    },
    rules() {
      return {
        vehicle_id: [value => !!value || "Required."],
        note: [value => !!value || "Required."]
      };
    }
  },

  created() {
    if (!this.driver) this.$router.push({ name: "Drivers" });
    this.$store.dispatch("Dashboard/fetchVehicles");
    this.$store.dispatch("Dashboard/fetchDriverTrips", this.driver);
  },

  mounted() {
    Event.$on("modalLoading", value => {
      this.modalLoading = value;
    });
  }
};
</script>

<style>
.compact-form {
  transform: scale(0.675);
  transform-origin: left;
}
.theme--light.v-data-table {
  background: none !important;
}

v-slide > .v-slide-group__next,
.v-slide-group__prev {
  flex: 0 0 0px !important;
  min-width: 0px !important;
}
</style>
